import * as api from "services/api";
import { getErrors } from "helpers/error";

export const CREATE_GROUP = "[GROUP CREATE] CREATE_GROUP";
export const CREATE_GROUP_ERROR = "[GROUP CREATE] CREATE_GROUP_ERROR";
export const CREATE_GROUP_SUCCESS = "[GROUP CREATE] CREATE_GROUP_SUCCESS";

export const SET_VALUE = "[GROUP CREATE] SET_VALUE";
export const CLEAR_VALUES = "[GROUP CREATE] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function createGroup(model, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: CREATE_GROUP
		});

		try {
			const { login } = getState();

			let response = await api.sendPost(`/group`, model, {
				Authorization: "Bearer " + login.token
			});

			if (response.ok) {
				let result = await response.json();
				dispatch({
					type: CREATE_GROUP_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				let result = await response.json();
				const errors = getErrors(result);

				dispatch({
					type: CREATE_GROUP_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);
			callback && callback(error);

			return dispatch({
				type: CREATE_GROUP_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
